export enum DeviceType {
  Desktop = 'desktop',
  Android = 'android',
  iOS = 'ios',
}

export interface BrowserType {
  name: string;
  deviceType: DeviceType;
  version?: number;
}

type browserRulesType = [string, RegExp][];

// NV-5516: Byta ut detect-browser
// Browser and os rules: https://github.com/DamonOehlman/detect-browser/blob/master/src/index.ts
// If more rules are needed, they can be added here and are available in above link
const userAgentRules: browserRulesType = [
  ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9.]+)(:?\s|$)/],
  ['crios', /CriOS\/([0-9.]+)(:?\s|$)/],
  ['fxios', /FxiOS\/([0-9.]+)/],
  ['android', /Android\s([0-9.]+)/],
  ['ios', /Version\/([0-9._]+).*Mobile.*Safari.*/],
];

export default class DeviceHelper {
  public static getDeviceType(): DeviceType {
    if (/android/i.test(navigator.userAgent)) {
      return DeviceType.Android;
    }
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) || (window.matchMedia('(pointer: coarse)').matches && navigator.userAgent.includes('Macintosh'))) {
      return DeviceType.iOS;
    }
    return DeviceType.Desktop;
  }

  public static getBrowser(): BrowserType {
    const userAgent = navigator.userAgent;
    let name = 'Other';
    let version: number | undefined;

    for (const [browserName, regex] of userAgentRules) {
      const match = regex.exec(userAgent);
      if (match) {
        name = browserName;
        version = match[1] ? parseFloat(match[1]) : undefined;
        break;
      }
    }
    const deviceType = this.getDeviceType();

    return {
      name,
      deviceType,
      version,
    };
  }
}
